import Empty from "../../../../components/Empty/Empty";
import { ProductsView } from "../Controls/Controls";
import ProductGridItem from "./ProductGridItem/ProductGridItem";
import ProductListItem from "./ProductListItem/ProductListItem";
import scss from "./ProductItems.module.scss";
import { useTranslation } from "react-i18next";

/**
 * Show the list of products.
 *
 * @param {{}[]} products The products to show.
 * @param {"grid"|"list"} view The type of the view to show products as.
 * @param {"single"|"double"} rows Limit the number of rows to show.
 *
 * @return {JSX.Element|null}
 * @constructor
 */

const ProductItems = ({ products, view = ProductsView.Grid, rows = false, location, translateKey }) => {
    const { t } = useTranslation();

    // Guard: Products supplied
    if (!products) {
        return null;
    }

    // Empty
    if (products.length === 0) {
        return <Empty message={t(`${translateKey}-text-no_thumb_to_show`)} />;
    }

    // Prepare the class name based on the view type
    const className = [scss[view]];

    // Show only the first couple of rows
    if (rows && scss[rows]) {
        className.push(scss[rows]);
    }

    return (
        <div className={className.join(" ")}>
            {products.map((product) =>
                view === ProductsView.List ? (
                    <ProductListItem key={product?.id} product={product} translateKey={`${translateKey}-product_thumb`} />
                ) : (
                    <ProductGridItem key={product?.basic_data?.id_product} product={product} translateKey={`${translateKey}-product_thumb`} />
                )
            )}
        </div>
    );
};

export default ProductItems;
